<template>
    <Modal
    :id="'cmp-dt-add-task'" 
      @cancelled="onCancel"
    >
      <template slot="header">Select Product and Task Group to add Tasks</template>
  
      <template slot="body">
        <SearchList
            :id="'release'"
            :items="productList.map((e)=>{
                return {
                    product_id:e.product_id,
                    label:e.catalog_no +' : '+e.format_name
                }
            })"
            :keyProperty="'product_id'"
            :label="'label'"
            @selected="onProductSelected"
            :isSearchable = "false"
        />

        <Dropdown
          :options="taskGroupTV"
          class="m2"
          :selected="taskGroupTV.find(v => v.value == task_group_id)"
          :placeholder="$t('task_group')"
          v-on:selectedChange="e => onDropdownChange('task_group_id', e)"
          :listHeight="120"
          :showValidationIcons="true"
          :immediateValidation="true"
           required
          @validated="e => onValidation('task_group_id', e)"
          box
        />
  
      </template>
      <template slot="options">
        <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
        <button class="dt-button v1 s6"
          :class="{ disabled: !IsFormValid }"
          :disabled="!IsFormValid"
          @click.stop="onTaskTemplateSubmit"
        >
          {{ $t("ok") }}
        </button>
      </template>
    </Modal>
  </template>
  
  <script>
  import Modal from "@dtplugins/modal/modal";
 import { dtTaskService } from "./dt-task-service";
 import SearchList from "@dtplugins/search-list/search-list";
 import { createTV } from "@/models/text-value.model"; 
  export default {
    components: {
      Modal
    },
    props: {},
    data: function() {
      return {
        selectedProduct: new Set(),
        productList:[],
        taskGroupList:[],
        task_group_id:null,	
        validationResult: {
        
        },
      };
    },
    mounted: async function() {
        
        const res = await dtTaskService.loadRelatedProductTasksToReleaseModalData(this.$route.query.external_id)
        console.log(":::::::::res",this.$route.query.external_id,res)
        this.productList = res?.data?.products||[]

        this.taskGroupList = res?.data?.task_groups||[]	
    },
    computed: {
        taskGroupTV:function(){
            return createTV(this.taskGroupList||[],"task_template_group","task_group_id");
        },
        IsFormValid: function () {
          return [...this.selectedProduct].length>0 &&  Object.values(this.validationResult).every((e) => e.valid)
        },
    },
    methods: {
        onValidation: function(name, value) {
          console.log("name, value",name, value,this.validationResult)
        this.$set(this.validationResult, name, value);
        
      
      },
      onCancel: function() {
        this.$emit("cancelled", true);
      },
      onTaskTemplateSubmit:async function(){
        
        console.log("::::::::PPPPPPPPP",[...this.selectedProduct].join(","),this.task_group_id,this.$route.query.external_id)

        const payload = { release_id:this.$route.query.external_id ,product_ids:[...this.selectedProduct].join(",") ,task_group_id:this.task_group_id };

        await dtTaskService.loadRelatedProductTasksToRelease({...payload})
        this.$emit("onSubmit")
        this.onCancel()
      },
      onProductSelected:function(selectedItem){
        console.log("TTT",selectedItem)
        
        this.selectedProduct = selectedItem;
        
        // const validationObject =[...selectedItem].length>0 ? {errorMessages:  [ "Valid" ], valid: true}:{errorMessages: [ "Must Select Product" ], valid: false}
        // this.validationResult = {
        //   product_ids:{
        //     ...validationObject
        //   }
        // }
        
        //this.$set(this.validationResult, nameValidation, validationObject)
        //this.onValidation(nameValidation,validationObject)
      },
      onDropdownChange: function(name, value) {
      let val = value.value;
      this[name] = val;
      

    },
  
    }
  };
  </script>
  
  <style lang="scss">
  .cmp-settings-task-template-form {
    .dt-checkbox-control {
      display: flex;
      padding-top: 12px;
      .dt-checkbox {
        max-width: 40px;
        margin: 3px 10px 0px 0px;
      }
    }
  }
  </style>
  